module.exports = __webpack_public_path__ + "img/service__banner——vi.d95d42a7.png";